import { SITE_ORIGIN } from './seo';

/** Harici logo/görsel URL'sini aynı kaynak proxy üzerinden sunar (CORS için). */
export function buildImageProxyUrl(imageUrl: string): string {
  const params = new URLSearchParams({ url: imageUrl });

  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${origin}/image-proxy.php?${params.toString()}`;
    }
    if (hostname === 'kitapcik.net' || hostname.endsWith('.kitapcik.net')) {
      return `/image-proxy.php?${params.toString()}`;
    }
  }

  return `${SITE_ORIGIN}/image-proxy.php?${params.toString()}`;
}

export function shouldProxyImageUrl(url: string): boolean {
  if (!url || url.startsWith('data:') || url.startsWith('blob:')) {
    return false;
  }

  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : SITE_ORIGIN);
    if (typeof window !== 'undefined' && parsed.origin === window.location.origin) {
      return false;
    }
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}
